import { render, staticRenderFns } from "./ProcessItem.vue?vue&type=template&id=21a7f918&scoped=true&"
import script from "./ProcessItem.vue?vue&type=script&lang=ts&"
export * from "./ProcessItem.vue?vue&type=script&lang=ts&"
import style0 from "./ProcessItem.vue?vue&type=style&index=0&id=21a7f918&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a7f918",
  null
  
)

export default component.exports